// extracted by mini-css-extract-plugin
export var printerCard = "_8x-1";
export var printerCardConfigured = "_8x-2";
export var printerCardError = "_8x-3";
export var printerCardsContainer = "_8x-0";
export var printerIcon = "_8x-8";
export var printerIconConfigured = "_8x-5";
export var printerIconContainer = "_8x-4";
export var printerIconError = "_8x-6";
export var printerIconUnconfigured = "_8x-7";
export var workstationsTableCard = "_8x-9";